import { useContext, useMemo } from 'react';
import { AuthContext } from '../AuthContext';

const usePermissions = () => {
  // Get both userInfo and getUserType to ensure this hook re-runs when userInfo changes
  const { getUserType, hasPermission} = useContext(AuthContext);
  

  // Get userType from the context - this will update when userInfo changes
  const userType = getUserType();

  // Check Organization Permissions - CRUD
  const canOrganizationCreate = useMemo(() => hasPermission('organization:create'), [hasPermission])
  const canOrganizationRead = useMemo(() => hasPermission('organization:read'), [hasPermission])
  const canOrganizationUpdate = useMemo(() => hasPermission('organization:update'), [hasPermission])
  const canOrganizationDelete = useMemo(() => hasPermission('organization:delete'), [hasPermission])

  // Check User PermisscanUserRead -canUserUpdate
  const canProjectCreate = useMemo(() => hasPermission('project:create'), [hasPermission])
  const canProjectRead = useMemo(() => hasPermission('project:read'), [hasPermission])
  const canProjectUpdate = useMemo(() => hasPermission('project:update'), [hasPermission])
  const canProjectDelete = useMemo(() => hasPermission('project:delete'), [hasPermission])

  // Check Roles Permissions - CRUD
  const canRoleCreate = useMemo(() => hasPermission('role:create'), [hasPermission])
  const canRoleRead = useMemo(() => hasPermission('role:read'), [hasPermission])
  const canRoleUpdate = useMemo(() => hasPermission('role:update'), [hasPermission])
  const canRoleDelete = useMemo(() => hasPermission('role:delete'), [hasPermission])

  // Check User Permissions - CRUD + Special Permissions
  const canUserCreate = useMemo(() => hasPermission('user:create'), [hasPermission])
  const canUserRead = useMemo(() => hasPermission('user:read'), [hasPermission])
  const canUserUpdate = useMemo(() => hasPermission('user:update'), [hasPermission])
  const canUserDelete = useMemo(() => hasPermission('user:delete'), [hasPermission])
  const canUserModifyProjectAccess = useMemo(() => hasPermission('user:modify_project_access'), [hasPermission])

  // Check Agent Permissions - CRUD + Publish/Unpublish
  const canAgentCreate = useMemo(() => hasPermission('agent:register'), [hasPermission]);
  const canAgentRead = useMemo(() => hasPermission('agent:read'), [hasPermission]);
  const canAgentUpdate = useMemo(() => hasPermission('agent:edit'), [hasPermission]);
  const canAgentDelete = useMemo(() => hasPermission('agent:delete'), [hasPermission]);
  const canAgentPublish = useMemo(() => hasPermission('agent:publish'), [hasPermission]);
  const canAgentUnpublish = useMemo(() => hasPermission('agent:unpublish'), [hasPermission]);

  // Check Solution Permissions - CRUD + Publish/Unpublish
  const canSolutionCreate = useMemo(() => hasPermission('solution:register'), [hasPermission]);
  const canSolutionRead = useMemo(() => hasPermission('solution:read'), [hasPermission]);
  const canSolutionUpdate = useMemo(() => hasPermission('solution:edit'), [hasPermission]);
  const canSolutionDelete = useMemo(() => hasPermission('solution:delete'), [hasPermission]);
  const canSolutionPublish = useMemo(() => hasPermission('solution:publish'), [hasPermission]);
  const canSolutionUnpublish = useMemo(() => hasPermission('solution:unpublish'), [hasPermission]);


  return {
    canOrganizationCreate, canOrganizationRead, canOrganizationUpdate, canOrganizationDelete,
    canProjectCreate, canProjectRead, canProjectUpdate, canProjectDelete,
    canRoleCreate, canRoleRead, canRoleUpdate, canRoleDelete,
    canUserCreate, canUserRead, canUserUpdate, canUserDelete, canUserModifyProjectAccess,
    canAgentCreate, canAgentRead, canAgentUpdate, canAgentDelete, canAgentPublish, canAgentUnpublish,
    canSolutionCreate, canSolutionRead, canSolutionUpdate, canSolutionDelete, canSolutionPublish, canSolutionUnpublish,
    userType
  };
};

export default usePermissions;